import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { Col } from 'reactstrap';
import { connect } from 'react-redux';
import { IPartsPercentsGraphic } from '../../types/interfaces';

const PartsPercentsGraphic = ({
  associations,
  etages
 }: IPartsPercentsGraphic) => {

  return <Col xs="12" className="mapTooltipField text-center fullFlexCenter" style={{wordBreak: "break-word", overflow: "hidden"}}>
    {[
      {floorName: "RDC", percentages: associations?.filter(e => e.ETAGE === "0") || []},
      {floorName: "1", percentages: associations?.filter(e => e.ETAGE === "1") || []},
      ...(Number(etages || 0) >= 3 ? [{floorName: "2", percentages: associations?.filter(e => e.ETAGE === "2") || []}] : []),
      ...(Number(etages || 0) >= 4 ? [{floorName: "3", percentages: associations?.filter(e => e.ETAGE === "3") || []}] : []),
      ...(Number(etages || 0) >= 5 ? [{floorName: "4", percentages: associations?.filter(e => e.ETAGE === "4") || []}] : []),
    ].map(e => ({...e, percent: e.percentages.reduce((e, t) => t.POURCENTAGE ? e + t.POURCENTAGE : e, 0)})).map((e, key) => <div className="mapAssociationContainer" key={key}>
      <div className="mapAssociationFloor">{e.floorName}</div>
      <div className="mapAssociationBox">
        <div className="mapAssociationLoaded" style={{height: e.percent + "%"}}></div>
        <div className="mapAssociationLines" style={{height: e.percent + "%"}}>{e.percentages.map((e, i) => <div className="mapAssociationLine" style={{height: e + "%", ...(i === 0 ? {border: "none"} : {})}}></div>)}</div>
        <div className="mapAssociationPercentText">{e.percent}%</div>
      </div>
    </div>)}
  </Col>
};

export default connect(null, { })(PartsPercentsGraphic);
